<div class="card">
    <div class="card-body">

        <div class="col-md-12 col-sm-12 ">
            <div class="form-floating" style="margin-bottom:20px">
                <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                <label for="floatingInputValueSubject">Search for people</label>
            </div>
            <!--<mat-form-field appearance="standard" style="width:100%">
                <mat-label>Search for people</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
            </mat-form-field>-->

            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                    <!-- ID Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td style="padding-top: 15px; padding-bottom: 15px;" mat-cell *matCellDef="let row">
                            <div class="row">
                                <div class="col-md-2">
                                    <img style="width: 40px; height: 40px; margin-right: 5px; border-radius: 50px;" [src]="row.contactLogo" />
                                </div>
                                <div class="col-md-10">
                                    <span>{{row.name}}</span><br /><span><small>{{row.title}}</small></span>
                                </div>
                            </div>


                        </td>
                    </ng-container>

                    <ng-container matColumnDef="organization">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Organization </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.organizationName}}
                        </td>
                    </ng-container>

                    <!-- Progress Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                        <td mat-cell *matCellDef="let row">
                        </td>
                    </ng-container>



                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr style="padding:10px" class="table_row" mat-row (click)="clickedRows(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="3">{{loadingMessage}}</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100, 200]" aria-label="Select page of users"></mat-paginator>
            </div>

        </div>
    </div>
</div>